import { PROVIDER_SEND_TURN_MAX_INPUT_CHARS } from "@cmmd-forge/contracts";
import { expandAssistantCitationsForProvider } from "@cmmd-forge/shared/assistantCitations";

/**
 * The 120k input ceiling is already enforced by `provider.ts`'s schema, so an
 * over-long prompt was never *sent* — it failed server-side with a generic
 * validation error, after the round trip, with nothing telling the user how
 * much to cut.
 *
 * Ported from t3code's `composerSubmission`. The number is the whole point: the
 * excess is what the user has to act on, so it leads, and both figures are
 * grouped (`120,000`) because a bare `120000` is unreadable at a glance.
 */
export function getComposerPromptLengthValidationMessage(prompt: string): string | null {
  const normalizedPrompt = prompt.trim();
  const inputLength = Math.max(
    normalizedPrompt.length,
    expandAssistantCitationsForProvider(normalizedPrompt).length,
  );
  const excessCharacters = inputLength - PROVIDER_SEND_TURN_MAX_INPUT_CHARS;
  if (excessCharacters <= 0) return null;

  const characterLabel = excessCharacters === 1 ? "character" : "characters";
  return `Prompt is ${excessCharacters.toLocaleString("en-US")} ${characterLabel} over the ${PROVIDER_SEND_TURN_MAX_INPUT_CHARS.toLocaleString("en-US")}-character limit. Shorten or split it before sending.`;
}
